const faq = [
  {
    question: "What is WebJam?",
    answer: "WebJam is a week-long team competition where teams of students will create fully functional web applications."
  },
  {
    question: "Where is WebJam being held?",
    answer: "WebJam is being held in an in-person environment, consisting of events/workshops and ceremonies. Correspondence and announcements will happen primarily through the WebJam Discord; registered participants will receive an invitation to the Discord closer to the start of WebJam."
  },
  {
    question: "When is WebJam?",
    answer: "WebJam is happening between November 14th - November 18th. The kickoff event is on Monday, November 18th, 2022 at 4PM PST and the final presentations are on Friday, November 18th, 2022 at 7PM PST."
  },
  {
    question: "How much does it cost?",
    answer: "Nothing. Attending WebJam is free."
  },
  {
    question: "Who can participate?",
    answer: "All UC Irvine students are welcome to participate."
  },
  {
    question: "How many people can be on a team?",
    answer: "Teams can be up to a maximum of 4 people."
  },
  {
    question: "What if I don’t have a team?",
    answer: "We will be assisting with team formations during the event by creating a Discord channel for team formations. Also, we plan to have a social after our kickoff ceremony for students to find potential teammates!"
  },
  {
    question: "How do I register?",
    answer: "You can register by filling out the following RSVP form above."
  },
  {
    question: "May I submit pre-existing projects for WebJam?",
    answer: "All design elements and code for your project must be created during the event. Pre-existing third party tools and frameworks are allowed. Coding in advance is not allowed, but planning and discussing with teammates prior to the event is allowed."
  },
  {
    question: "What if I don’t have any prior experience with web development?",
    answer: "Many ICS clubs will be hosting workshops throughout the week to assist participants get started with web development."
  },
  {
    question: "What if my question isn’t answered here?",
    answer: "If your question isn’t answered in the FAQ, please leave a question in the WebJam Discord or email us at <a href=\"mailto:icssc@uci.edu\">icssc@uci.edu</a>."
  },
  {
    question: "What are the rules?",
    answer: "Please refer to the <a href=\"https://docs.google.com/document/d/1T2Dh_FVx0zU8xhNC2CHDMb_0xg-j2oFBUfp-M0C4FqM/edit\">WebJam Rules and Code of Conduct</a> for more information."
  },
];

export default faq;
